import React, { useState } from 'react';
import { numberToWords } from '../../../utils/functions/numberToWords';
import logo from "./image.png";
const Quotation = ({ data, proposalRef, page, setPage, firstName, lastName, email }) => {
    const [customerName, setCustomerName] = useState(firstName + ' ' + lastName);
    const [baseAmount, setBaseAmount] = useState((Number(String(data["Price"]).replace(/,/g, '')) || 0));
    // Calculate discounted amount based on Discount % field
    const discountPercent = Number(data["Discount %"]) || 0;
    const tcsPercent = 1; // TCS percent, can be dynamic if needed
    const discountedAmount = baseAmount - (baseAmount * discountPercent / 100);
    const tcsAmount = discountedAmount * tcsPercent / 100;
    const finalAmount = discountedAmount + tcsAmount;
    const [modalOpen, setModalOpen] = useState(false);
    const [modalField, setModalField] = useState<'customerName' | 'amount' | null>(null);
    const [editValue, setEditValue] = useState<string>('');
    const formatAmount = (amt: number) => amt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // Open modal handler
    const handleOpenModal = (field: 'customerName' | 'amount') => {
        setModalField(field);
        setEditValue(field === 'customerName' ? customerName : String(baseAmount));
        setModalOpen(true);
    };
    // console.log('baseAmount:', baseAmount);
    // console.log('discountPercent:', discountPercent);
    // console.log('discountedAmount:', discountedAmount);
    // console.log('tcsPercent:', tcsPercent);
    // console.log('tcsAmount:', tcsAmount);
    // console.log('finalAmount:', finalAmount);
    // console.log(data["Price"], "Price");
    // Save modal handler
    const handleSave = () => {
        if (modalField === 'customerName') {
            setCustomerName(editValue);
        } else if (modalField === 'amount') {
            const num = Number(editValue);
            if (!isNaN(num)) setBaseAmount(num);
        }
        setModalOpen(false);
        setModalField(null);
    };

    // EditModal component
    type EditModalProps = {
        open: boolean;
        field: 'customerName' | 'amount' | null;
        value: string;
        onChange: (value: string) => void;
        onClose: () => void;
        onSave: () => void;
    };
    const EditModal: React.FC<EditModalProps> = ({ open, field, value, onChange, onClose, onSave }) => {
        // Hooks must always be called
        const inputRef = React.useRef<HTMLInputElement>(null);
        React.useEffect(() => { if (open) inputRef.current?.focus(); }, [open]);
        if (!open || !field) return null;
        return (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                <div style={{ background: '#fff', padding: 32, borderRadius: 8, minWidth: 320, boxShadow: '0 2px 16px #3333' }}>
                    <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 18 }}>Edit {field === 'customerName' ? 'Customer Name' : 'Amount'}</div>
                    <input
                        ref={inputRef}
                        type={field === 'amount' ? 'number' : 'text'}
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        style={{ width: '100%', padding: '8px 12px', fontSize: 15, border: '1px solid #bbb', borderRadius: 4, marginBottom: 18 }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                        <button onClick={onClose} style={{ padding: '6px 18px', border: 'none', background: '#eee', borderRadius: 4, fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
                        <button onClick={onSave} style={{ padding: '6px 18px', border: 'none', background: '#007bff', color: '#fff', borderRadius: 4, fontWeight: 600, cursor: 'pointer' }}>Update</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='m-2 p-2'>


            <div className='card p-10' ref={proposalRef}>
                {/* --- PAGE 1 --- */}
                {page === 1 && (
                    <>

                        {/* Header */}
                        <div style={{ display: 'flex', alignItems: 'flex-start', position: 'relative', minHeight: 70, marginBottom: 0 }}>
                            {/* Logo */}
                            <img src={logo} alt="Eicher Logo" style={{ height: 55, marginRight: 18, marginTop: 2 }} />
                            {/* Diagonal line */}

                            {/* Right-aligned company info */}
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start', marginTop: 2 }}>
                                <div style={{ fontWeight: 700, fontSize: 15, textAlign: 'right', marginBottom: 2 }}>Shree Motors Pvt. Ltd.</div>
                                <div style={{ fontWeight: 400, fontSize: 13, fontStyle: 'italic', letterSpacing: 1, textAlign: 'right', marginTop: 0 }}>TRUCKS AND BUSES</div>
                            </div>
                        </div>
                        {/* Underline and left-aligned BUSINESS PROPOSAL */}
                        <div style={{ fontWeight: 'bold', fontSize: 22, letterSpacing: 1, textAlign: 'center', marginBottom: 12, marginLeft: 2 }}>BUSINESS PROPOSAL</div>
                        <div style={{ borderBottom: '2px solid #222', marginBottom: 8, marginTop: -8, width: '100%' }}></div>

                        {/* Info Grid */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 1fr', gap: 12, margin: '24px 0 0 0', fontSize: 14 }}>
                            <div className='cursor-pointer' onClick={() => handleOpenModal('customerName')}>
                                <div><b>Customer Name:</b> {customerName}</div>
                                <div><b>Customer Id:</b> 12888996</div>
                            </div>
                            <div>
                                <div><b>Quotation No:</b> {data["Quotation No"]}</div>
                                <div><b>Valid Upto:</b> {data["Quote Valid Upto"]}</div>
                            </div>
                            <div>
                                <div><b>Dealership Contact Person:</b> VINOD .</div>
                                <div><b>Phone No:</b> 7015487392</div>
                            </div>
                        </div>
                        <div style={{ margin: '4px 0 16px 0', fontSize: 14 }}><b>Email Id:</b> SALES.ROHTAK@SHREEMOTORS.COM</div>
                        <div style={{ marginBottom: 10, fontSize: 14 }}>
                            <b>Address:</b> BHARAT BHUSHAN MATERIAL SUPPLIERS<br />
                            VPO TITOLI ROHTAK HARYANA, ROHTAK H.O, ROHTAK, ROHTAK, ROHTAK, -124001, Haryana
                        </div>

                        {/* Greeting */}
                        <div style={{ background: '#f7f7f7', padding: 10, border: '1px solid #eee', marginBottom: 18, fontSize: 14 }}>
                            Dear Sir/ Madam,<br />
                            Thank you for your valuable enquiry.<br />
                            We are pleased to offer our quotation for the following Eicher vehicle for your kind consideration:
                        </div>

                        {/* Main Quotation Table */}
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, marginBottom: 16 }}>
                            <thead>
                                <tr style={{ background: '#f1f1f1' }}>
                                    <th style={{ border: '1px solid #bbb', padding: 8, textAlign: 'left', width: '70%' }}>Particulars</th>
                                    <th style={{ border: '1px solid #bbb', padding: 8, textAlign: 'right' }}>Amount (Rs)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 8 }}>
                                        Vehicle Price (inclusive of 28.00 % GST configuration):<br />
                                        Model: 91407546 Pro6028T G BSVI LYPRM 11X20 16BBGTM VX<br />
                                        Quantity: 2 Units<br />
                                        GVW: 28000 KG<br />
                                        Engine Power: 260 HP MAX ENG POWER<br />
                                        Body Type: FET<br />
                                        Wheel Base: 4000 MM<br />
                                        Variant: {data["Variant"]}<br />
                                        Cargo Body Length (for truck):<br />
                                        Seating Capacity: 2<br />
                                        Fuel Type: {data["Fuel Type"]}<br />
                                        Tyre Size: 11.00X20-16PR-RIB
                                    </td>
                                    <td onClick={() => handleOpenModal('amount')} style={{ border: '1px solid #bbb', padding: 8, textAlign: 'right', verticalAlign: 'top' }}>{formatAmount(Number(String(data["Price"]).replace(/,/g, '')))}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Additional Offers */}
                        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 10 }}>Additional Soft Offers Availed</div>

                        {/* Charges Table */}
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, marginBottom: 16 }}>
                            <tbody>

                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6, width: "70%" }}>Temporary Registration (T/R) Charges</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right', }}>0.00</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Registration Charges</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>0.00</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Body Building Charge</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>0.00</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Transportation Charges</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>0.00</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Other Charges</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>0.00</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Customer Offer</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>0.00</td>
                                </tr>
                                <tr style={{ fontWeight: 600 }}>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Discount %</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>{data["Discount %"]}</td>
                                </tr>
                                <tr style={{ fontWeight: 600 }}>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Total Offer Price Before TCS:</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>{formatAmount(discountedAmount)}</td>
                                </tr>
                                <tr style={{ fontWeight: 600 }}>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>TCS 1.00 % (if Applicable):</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right', color: 'blue' }}>{formatAmount(tcsAmount)} {/* Only TCS amount */}</td>
                                </tr>
                                <tr style={{ fontWeight: 700, background: '#f1f1f1' }}>
                                    <td style={{ border: '1px solid #bbb', padding: 6 }}>Total Offer Price After TCS:</td>
                                    <td style={{ border: '1px solid #bbb', padding: 6, textAlign: 'right' }}>{formatAmount(finalAmount)}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Amount in Words and Auth */}
                        <div>
                            <b>Amount in Words:</b> {numberToWords(finalAmount)}
                        </div>

                        {/* Footer / Address */}
                        <div style={{ background: '#f7f7f7', padding: 10, border: '1px solid #eee', fontSize: 13 }}>
                            <div style={{ fontWeight: 600 }}>
                                Registration Address: 1-A/240-243, Neelam Bata Road NIT Faridabad, Faridabad 0129-6461371<br />
                                CIN: U34102HR1986PTC025109<br />
                                GST No: 06AAECS0284P1ZZ
                            </div>
                            <div style={{ marginTop: 6 }}>
                                <b>Dealership Address:</b> Dehcora Road, Rohad Bypass, Tehsil - Bahadurgarh, Distt- Jhajjar, Bahadurgarh<br />
                                <b>Workshop Address:</b> Dehcora Road, Rohad Bypass, Tehsil - Bahadurgarh, Distt- Jhajjar, Bahadurgarh 01276-278166
                            </div>
                        </div>


                        <EditModal
                            open={modalOpen}
                            field={modalField}
                            value={editValue}
                            onChange={setEditValue}
                            onClose={() => setModalOpen(false)}
                            onSave={handleSave}
                        />

                    </>
                )}

                {page === 2 && (
                    <>
                        {/* Header */}
                        <div style={{ display: 'flex', alignItems: 'flex-start', position: 'relative', minHeight: 70, marginBottom: 0 }}>
                            {/* Logo */}
                            <img src={logo} alt="Eicher Logo" style={{ height: 55, marginRight: 18, marginTop: 2 }} />
                            {/* Diagonal line */}

                            {/* Right-aligned company info */}
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start', marginTop: 2 }}>
                                <div style={{ fontWeight: 700, fontSize: 15, textAlign: 'right', marginBottom: 2 }}>Shree Motors Pvt. Ltd.</div>
                                <div style={{ fontWeight: 400, fontSize: 13, fontStyle: 'italic', letterSpacing: 1, textAlign: 'right', marginTop: 0 }}>TRUCKS AND BUSES</div>
                            </div>
                        </div>
                        {/* Underline and left-aligned BUSINESS PROPOSAL */}
                        <div style={{ fontWeight: 'bold', fontSize: 22, letterSpacing: 1, textAlign: 'center', marginBottom: 12, marginLeft: 2 }}>BUSINESS PROPOSAL</div>
                        <div style={{ borderBottom: '2px solid #222', marginBottom: 8, marginTop: -8, width: '100%' }}></div>

                        {/* Terms & Conditions Box */}
                        <div style={{ border: '2px solid #444', margin: '36px 0 0 0', padding: 0, borderRadius: 4, minHeight: 420 }}>
                            <div style={{ fontWeight: 700, fontSize: 18, textAlign: 'center', margin: '18px 0 18px 0' }}>Terms & Conditions:</div>
                            <ol style={{ fontSize: 14, margin: '0 24px 24px 24px', paddingLeft: 10, color: '#222' }}>
                                <li style={{ marginBottom: 10 }}>
                                    The company may change the price and customer offer without notice. The price and customer offer applicable at the time of delivery shall be applicable. Any change in taxes &amp; levies shall be applicable at the time of delivery.
                                </li>
                                <li style={{ marginBottom: 10 }}>
                                    Full payment to be made in advance favoring payable at .
                                </li>
                                <li style={{ marginBottom: 10 }}>
                                    Above price includes the standard accessories &amp; fitments as per manufacturer specifications.
                                </li>
                                <li style={{ marginBottom: 10 }}>
                                    All disputes are subject to jurisdiction
                                </li>
                                <li style={{ marginBottom: 10 }}>
                                    Delivery period - Within ________ days after full payment
                                </li>
                                <li style={{ marginBottom: 10 }}>
                                    Delivery indication given is subject to 'Force Majeure' clause. Any delay or failure due to any reasons would not entitle the buyer to cancel the order nor make the company liable to any consequential damage/ cost.
                                </li>
                            </ol>
                        </div>
                        {/* Footer / Address */}
                        {/* Footer / Address */}
                        <div style={{ background: '#f7f7f7', padding: 10, border: '1px solid #eee', fontSize: 13 }}>
                            <div style={{ fontWeight: 600 }}>
                                Registration Address: 1-A/240-243, Neelam Bata Road NIT Faridabad, Faridabad 0129-6461371<br />
                                CIN: U34102HR1986PTC025109<br />
                                GST No: 06AAECS0284P1ZZ
                            </div>
                            <div style={{ marginTop: 6 }}>
                                <b>Dealership Address:</b> Dehcora Road, Rohad Bypass, Tehsil - Bahadurgarh, Distt- Jhajjar, Bahadurgarh<br />
                                <b>Workshop Address:</b> Dehcora Road, Rohad Bypass, Tehsil - Bahadurgarh, Distt- Jhajjar, Bahadurgarh 01276-278166
                            </div>
                        </div>

                    </>
                )}
            </div>
        </div>
    );
};

export default Quotation;